/**
 * One optional question at cancel and at trial end (Paul, Oct 28 2026). Capture only — the
 * answer never changes billing. Merged into every catalog by translations.js.
 */
const leaveReasonI18n = {
  en: {
    'leave.question': 'Before you go — what was the main reason? (optional)',
    'leave.playback_problems': 'Playback problems', 'leave.my_gear_not_supported': 'My gear is not supported', 'leave.missing_feature': 'Missing a feature I need',
    'leave.price': 'Price', 'leave.use_another_app': 'Using another app', 'leave.not_listening_enough': 'Not listening enough', 'leave.other': 'Other',
    'leave.placeholder': 'Anything you want to add', 'leave.send': 'Send', 'leave.thanks': 'Thank you — that helps.',
  },
  es: {
    'leave.question': 'Antes de irte, ¿cuál fue el motivo principal? (opcional)',
    'leave.playback_problems': 'Problemas de reproducción', 'leave.my_gear_not_supported': 'Mi equipo no es compatible', 'leave.missing_feature': 'Falta una función que necesito',
    'leave.price': 'Precio', 'leave.use_another_app': 'Uso otra aplicación', 'leave.not_listening_enough': 'No escucho lo suficiente', 'leave.other': 'Otro',
    'leave.placeholder': 'Algo más que quieras añadir', 'leave.send': 'Enviar', 'leave.thanks': 'Gracias, eso ayuda.',
  },
  fr: {
    'leave.question': 'Avant de partir, quelle était la raison principale ? (facultatif)',
    'leave.playback_problems': 'Problèmes de lecture', 'leave.my_gear_not_supported': "Mon matériel n'est pas pris en charge", 'leave.missing_feature': 'Il manque une fonction dont j’ai besoin',
    'leave.price': 'Prix', 'leave.use_another_app': "J'utilise une autre application", 'leave.not_listening_enough': "Je n'écoute pas assez", 'leave.other': 'Autre',
    'leave.placeholder': 'Quelque chose à ajouter', 'leave.send': 'Envoyer', 'leave.thanks': 'Merci, cela nous aide.',
  },
  de: {
    'leave.question': 'Bevor Sie gehen – was war der Hauptgrund? (optional)',
    'leave.playback_problems': 'Probleme bei der Wiedergabe', 'leave.my_gear_not_supported': 'Meine Geräte werden nicht unterstützt', 'leave.missing_feature': 'Mir fehlt eine Funktion',
    'leave.price': 'Preis', 'leave.use_another_app': 'Ich nutze eine andere App', 'leave.not_listening_enough': 'Ich höre zu wenig', 'leave.other': 'Sonstiges',
    'leave.placeholder': 'Möchten Sie etwas ergänzen?', 'leave.send': 'Senden', 'leave.thanks': 'Danke, das hilft.',
  },
  it: {
    'leave.question': 'Prima di andare, qual è stato il motivo principale? (facoltativo)',
    'leave.playback_problems': 'Problemi di riproduzione', 'leave.my_gear_not_supported': 'Il mio impianto non è supportato', 'leave.missing_feature': 'Manca una funzione che mi serve',
    'leave.price': 'Prezzo', 'leave.use_another_app': "Uso un'altra app", 'leave.not_listening_enough': 'Non ascolto abbastanza', 'leave.other': 'Altro',
    'leave.placeholder': 'Qualcosa da aggiungere', 'leave.send': 'Invia', 'leave.thanks': 'Grazie, ci è utile.',
  },
  pt: {
    'leave.question': 'Antes de sair, qual foi o principal motivo? (opcional)',
    'leave.playback_problems': 'Problemas de reprodução', 'leave.my_gear_not_supported': 'Meu equipamento não é compatível', 'leave.missing_feature': 'Falta um recurso de que preciso',
    'leave.price': 'Preço', 'leave.use_another_app': 'Uso outro aplicativo', 'leave.not_listening_enough': 'Não ouço o suficiente', 'leave.other': 'Outro',
    'leave.placeholder': 'Algo que queira acrescentar', 'leave.send': 'Enviar', 'leave.thanks': 'Obrigado, isso ajuda.',
  },
  ja: {
    'leave.question': '最後に、主な理由を教えてください（任意）',
    'leave.playback_problems': '再生のトラブル', 'leave.my_gear_not_supported': '自分の機器が対応していない', 'leave.missing_feature': '必要な機能がない',
    'leave.price': '価格', 'leave.use_another_app': '別のアプリを使っている', 'leave.not_listening_enough': 'あまり聴いていない', 'leave.other': 'その他',
    'leave.placeholder': 'ほかにあればご記入ください', 'leave.send': '送信', 'leave.thanks': 'ありがとうございます。参考になります。',
  },
  ko: {
    'leave.question': '떠나시기 전에 가장 큰 이유를 알려 주세요 (선택)',
    'leave.playback_problems': '재생 문제', 'leave.my_gear_not_supported': '내 장비가 지원되지 않음', 'leave.missing_feature': '필요한 기능이 없음',
    'leave.price': '가격', 'leave.use_another_app': '다른 앱을 사용함', 'leave.not_listening_enough': '충분히 듣지 않음', 'leave.other': '기타',
    'leave.placeholder': '덧붙이고 싶은 말', 'leave.send': '보내기', 'leave.thanks': '감사합니다. 도움이 됩니다.',
  },
  zh: {
    'leave.question': '离开之前，主要原因是什么？（可选）',
    'leave.playback_problems': '播放问题', 'leave.my_gear_not_supported': '我的设备不受支持', 'leave.missing_feature': '缺少我需要的功能',
    'leave.price': '价格', 'leave.use_another_app': '在用其他应用', 'leave.not_listening_enough': '听得不够多', 'leave.other': '其他',
    'leave.placeholder': '还有什么想补充的', 'leave.send': '发送', 'leave.thanks': '谢谢，这很有帮助。',
  },
  nl: {
    'leave.question': 'Voordat je gaat: wat was de belangrijkste reden? (optioneel)',
    'leave.playback_problems': 'Problemen met afspelen', 'leave.my_gear_not_supported': 'Mijn apparatuur wordt niet ondersteund', 'leave.missing_feature': 'Ik mis een functie',
    'leave.price': 'Prijs', 'leave.use_another_app': 'Ik gebruik een andere app', 'leave.not_listening_enough': 'Ik luister te weinig', 'leave.other': 'Anders',
    'leave.placeholder': 'Wil je nog iets toevoegen?', 'leave.send': 'Versturen', 'leave.thanks': 'Bedankt, dat helpt.',
  },
  sv: {
    'leave.question': 'Innan du går – vad var huvudskälet? (valfritt)',
    'leave.playback_problems': 'Problem med uppspelning', 'leave.my_gear_not_supported': 'Min utrustning stöds inte', 'leave.missing_feature': 'Saknar en funktion jag behöver',
    'leave.price': 'Pris', 'leave.use_another_app': 'Använder en annan app', 'leave.not_listening_enough': 'Lyssnar inte tillräckligt', 'leave.other': 'Annat',
    'leave.placeholder': 'Något du vill lägga till', 'leave.send': 'Skicka', 'leave.thanks': 'Tack, det hjälper.',
  },
};

export default leaveReasonI18n;
